const { Mixin } = require('@xingternal/hops');

class ExposeVisitorIdMixin extends Mixin {
  enhanceServerData(serverData, req, res) {
    return {
      ...serverData,
      visitorId: res.locals.visitorId,
    };
  }
}

module.exports = ExposeVisitorIdMixin;
